<h2 mat-dialog-title>{{ title | translate }}</h2>

<mat-dialog-content>
  <div class="mat-dialog-content">
    <form class="example-form">
      <p class="title">
        {{ "brand.campaign.promoAds.placements.dialogSubtitle" | translate }}
      </p>
      <mat-form-field floatLabel="auto" class="placement-input">
        <textarea
          [(ngModel)]="newPlacementsInput"
          name="placementInput"
          matInput
          cdkTextareaAutosize
          placeholder="{{
            'brand.campaign.promoAds.placements.enterPlacement' | translate
          }}"
        ></textarea>
      </mat-form-field>
      <p *ngIf="newPlacementsInput === ''" class="add-placement disabled">
        {{ "brand.campaign.promoAds.placements.addPlacements" | translate }}
      </p>
      <p
        *ngIf="newPlacementsInput !== ''"
        class="add-placement"
        (click)="addPlacements()"
      >
        {{
          "brand.campaign.promoAds.placements.addNumberPlacements"
            | translate: { numberPlacements: getNumberOfLines() }
        }}
      </p>
    </form>
    <div class="placements-selected">
      <p *ngIf="!placements.length" class="no-selected">
        {{ "brand.campaign.promoAds.placements.noSelected" | translate }}
      </p>
      <p *ngIf="placements.length" class="no-selected">
        {{
          "brand.campaign.promoAds.placements.selected"
            | translate: { numberSelected: placements.length }
        }}
      </p>
      <div
        *ngFor="let item of placements; let idx = index"
        class="selected-item"
      >
        <p>{{ item }}</p>
        <img
          class="remove-selected"
          src="../../../../../assets/images/cancel_black_24dp.svg"
          (click)="removePlacement(idx)"
        />
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button class="btn btn--transparent" [mat-dialog-close]="">
    {{ "shared.cancel" | translate }}
  </button>
  <button class="btn btn--primary" (click)="save()">
    {{ "shared.save" | translate }}
  </button>
</mat-dialog-actions>
